import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core'
import {faUserSecret, faPen, faTrash, faScroll, faInfo, faTimes} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

var MobileDetect = require('mobile-detect'),
    md = new MobileDetect(window.navigator.userAgent);


library.add(faInfo, faUserSecret, faPen, faTrash, faScroll, faTimes)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;
// Vue.prototype.$http = axios;

Vue.config.warnHandler = function (msg, vm, trace) {
};

export var globalStore = new Vue({
    data: {
        selectedVessel:'',
        selectedIMO:'',
        selectedEngine:'',
        twinEngine:false,
        gasEngine:false,
        availableVessels:[],
        cylCount:0,
        tcCount:0,
        allowNav:true,
        userLogged:false,
        userProfile:{},
        signals:{},
        reference:{},
        mapping:{},
        ehcMapping:{},
        faultMapping:{},
        units:{},
        loadDiagram:{},
        limits:{},
        type:'last',
        faults:[],
        dashboard:{},
        mapData:{},
        chartData:{},
        mapDate:'',
        alertFilters: [],
        alerts:[],
        validDate:false,
        checkedDate:false,
        dateTo:'',
        alertDate:'',
        config: {},
        MyEvent: null,
        notificationId: null,
        auth_token: '',
        requestedBeforeLogin: ''
    },
    methods: {
        is_mobile : function () {
            return md.mobile() != null;
        }
    },
    created() {
        axios.get('/config.json').then(async (response) => {
            this.config = response.data;

            await localStorage.setItem('config', JSON.stringify(response.data));

            if (!this.is_mobile()) {
                window.location.href = this.config.redirect_to + "/login";
            }
        });

        this.MyEvent = new class {
            constructor() {
                this.vue = new Vue();
            }

            fire(event, data = null) {
                this.vue.$emit(event, data);
            }

            listen(event, callback) {
                this.vue.$on(event, callback);
            }
        };
    }
});

export var vessels = new Vue({
    data: {
        vessels: {}
    }
});

new Vue({
    render: h => h(App),
    router
}).$mount('#app');


